module.exports = __webpack_public_path__ + "static/media/banner-offer-pro@2x.57b97d84.png";